import * as React from "react";
const Meetups = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={32}
    height={32}
    fill="none"
    {...props}
  >
    <rect width={32} height={32} fill="#fff" fillOpacity={0.08} rx={16} />
    <mask
      id="aMeetups"
      width={20}
      height={20}
      x={6}
      y={6}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: "alpha",
      }}
    >
      <path fill="#D9D9D9" d="M6 6h20v20H6z" />
    </mask>
    <g mask="url(#aMeetups)">
      <path
        fill="#F1F5F9"
        d="M11 19.333h6.667v-.458c0-.611-.306-1.104-.917-1.48-.61-.374-1.416-.562-2.416-.562s-1.806.188-2.417.563c-.611.375-.917.868-.917 1.479v.458ZM14.334 16c.458 0 .85-.163 1.177-.49.326-.326.49-.718.49-1.177 0-.458-.164-.85-.49-1.177a1.605 1.605 0 0 0-1.177-.49c-.459 0-.851.164-1.177.49-.327.327-.49.719-.49 1.177 0 .459.163.851.49 1.178.326.326.718.489 1.177.489Zm-5 6.667c-.459 0-.851-.164-1.177-.49A1.605 1.605 0 0 1 7.667 21V11c0-.458.163-.85.49-1.177.326-.326.718-.49 1.177-.49h10c.458 0 .85.164 1.177.49.326.326.49.719.49 1.177v3.75l3.333-3.333v9.166L21 17.25V21c0 .458-.163.85-.49 1.177-.326.326-.718.49-1.176.49h-10Zm0-1.667h10V11h-10v10Z"
      />
    </g>
  </svg>
);
export default Meetups;
